import { MessagePartner } from "../../types";

export const filterPartners = (usersInConversation: MessagePartner[], userId: string): MessagePartner[] => {
	const partners = [];
	usersInConversation.forEach(partner => {
		if (partner.userId !== userId && partner.active) {
			partners.push(partner);
		}
	});
	return partners;
};
